import React from "react";
import { Slider } from "@blueprintjs/core";
import { ShowHide } from "components/layout";
import { Numeric } from "components/formatting";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./FormFields.css";

export function FormSlider({
    min = 0,
    max = 10,
    stepSize = 0.1,
    labelStepSize = 10,
    value = 0,
    onChange = () => {},
    showLabels = false,
    leftLabelHeader = "",
    leftLabelValue = "",
    rightLabelHeader = "",
    rightLabelValue = "",
    isSaving = false,
    isLoading = false
}) {
    function customRenderer(selectedValue) {
        return <Numeric>{selectedValue}</Numeric>;
    }

    return (
        <div>
            <ShowHide
                evaluator={showLabels}
                show={
                    <div className="slider-layout">
                        <div>
                            <label
                                className={classNames({
                                    "bp6-skeleton": isLoading,
                                })}
                            >
                                {leftLabelHeader}
                            </label>
                            <p
                                className={classNames({
                                    "bp6-skeleton": isLoading,
                                })}
                            >
                                {leftLabelValue}
                            </p>
                        </div>
                        <div className="text-align-right">
                            <label
                                className={classNames({
                                    "bp6-skeleton": isLoading,
                                })}
                            >
                                {rightLabelHeader}
                            </label>
                            <p
                                className={classNames({
                                    "bp6-skeleton": isLoading,
                                })}
                            >
                                {rightLabelValue}
                            </p>
                        </div>
                    </div>
                }
            />
            <Slider
                min={min}
                max={max}
                stepSize={stepSize}
                labelStepSize={labelStepSize}
                value={value}
                onChange={onChange}
                labelRenderer={customRenderer}
                className={classNames({ "bp6-skeleton": isLoading })}
                disabled={isSaving}
            />
        </div>
    );
}

FormSlider.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    stepSize: PropTypes.number,
    labelStepSize: PropTypes.number,
    value: PropTypes.number,
    onChange: PropTypes.func,
    showLabels: PropTypes.bool,
    leftLabelHeader: PropTypes.string,
    leftLabelValue: PropTypes.any,
    rightLabelHeader: PropTypes.string,
    rightLabelValue: PropTypes.any,
    isLoading: PropTypes.bool,
    isSaving: PropTypes.bool,
};
